import { useMutation } from '@tanstack/react-query';
import { createUrl } from 'src/core/api/utils/createUrl';
import { fetch as fetchRedirect } from 'src/utils/refetch';
import { ChangePrimaryPaymentBodyModel } from '../models/ChangePrimaryPaymentBodyModel';
import { queryClient } from '../../core/root/components/ReactQueryProvider/ReactQueryProvider';

const useChangePrimaryPaymentMutation = () => {
  const { mutate: mutateChangePrimaryPayment, isLoading: isChangePrimaryPaymentMutationLoading } = useMutation({
    mutationFn: async (data: ChangePrimaryPaymentBodyModel) => {
      const response = await fetchRedirect(createUrl(`/payment/change-primary`), {
        method: 'POST',
        body: JSON.stringify(data),
      });

      if (!response.response.ok) {
        return response.body;
      }
      return response.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['paymentTypesUsed']);
    },
  });

  return { mutateChangePrimaryPayment, isChangePrimaryPaymentMutationLoading };
};

export default useChangePrimaryPaymentMutation;
